export default __webpack_public_path__ + "static/media/COVIDSATIONS.27a1f7c3.jpg";